import React from "react";
import { Badge, ListGroup } from "react-bootstrap";

const STAGE_VARIANT = { PENDING: "warning", APPROVED: "success", REJECTED: "danger", CHANGES_REQUESTED: "danger", CANCELLED: "secondary" };

// Phase 3C, §27/§29/§30. `stages`: GET /api/form-submissions/:id/review-stages
// (every revision — each row already carries its own submission_revision).
export default function FormReviewTimeline({ stages }) {
  if (!stages || !stages.length) {
    return <div className="text-muted small">No review or approval stage was required for this submission.</div>;
  }

  return (
    <ListGroup variant="flush">
      {stages.map((stage) => (
        <ListGroup.Item key={stage.id} className="px-0">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              <strong>{stage.stage_type === "APPROVAL" ? "Approval" : "Review"}</strong>
              <span className="text-muted small ms-2">Revision {stage.submission_revision}</span>
              {stage.reviewer_name && <span className="text-muted small ms-2">— {stage.reviewer_name}</span>}
            </span>
            <Badge bg={STAGE_VARIANT[stage.status] || "secondary"}>{stage.status}</Badge>
          </div>
          {stage.decision_at && (
            <div className="small text-muted">
              Decided {new Date(stage.decision_at).toLocaleString()}{stage.decision_by_name ? ` by ${stage.decision_by_name}` : ""}
            </div>
          )}
          {stage.remarks && <div className="small mt-1">"{stage.remarks}"</div>}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
}
